export const PAGE_SIZE = 10;

export function statusLabel(value) {
  const status = String(value || 'PLANNING').toUpperCase();
  if (['IN_PROGRESS', 'ONGOING'].includes(status)) return 'Ongoing';
  if (['PLANNING', 'NOT_STARTED'].includes(status)) return 'Planning';
  return status.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function normalizeProject(project) {
  const client = project.client || {};
  const visibility = project.isPublic ?? project.is_public ?? project.isPublished ?? project.published ?? project.publiclyVisible ?? project.visibility;
  return {
    ...project,
    projectCode: project.projectCode || project.project_code || String(project.id ?? ''),
    projectName: project.projectName || project.project_name || project.title || 'Untitled project',
    clientName: project.clientName || (typeof client === 'string' ? client : client.userName || client.fullName || client.name) || 'Not assigned',
    category: String(project.category || '').toUpperCase(),
    status: statusLabel(project.status),
    isPublic: visibility === true || visibility === 1 || ['TRUE', 'PUBLIC'].includes(String(visibility).toUpperCase()),
    startDate: project.startDate || project.start_date,
    createdAt: project.createdAt || project.created_at,
  };
}

export function selectProjects(projects, { query, status, category, visibility, sort }) {
  const search = query.trim().toLowerCase();
  return projects.filter((project) =>
    (!search || [project.id, project.projectCode, project.projectName, project.clientName, project.location].some((value) => String(value ?? '').toLowerCase().includes(search))) &&
    (!status || project.status === status) &&
    (!category || project.category === category) &&
    (!visibility || project.isPublic === (visibility === 'public'))
  ).sort((a, b) => {
    if (sort === 'name') return a.projectName.localeCompare(b.projectName);
    const dateA = Date.parse(a.createdAt) || 0;
    const dateB = Date.parse(b.createdAt) || 0;
    return sort === 'oldest' ? dateA - dateB : dateB - dateA;
  });
}
